// @ts-nocheck
import { Button, Col, Container, Row, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Label, Select } from 'design-react-kit';
import React, { useState, useContext, useEffect } from 'react';
import WidgetMenu from 'pa_kit/apps/menus/components/widget_menu';
import WidgetNews from '../../news/components/widget_news';
import WidgetNewsHome from '../../news/components/widget_news_home';
import WidgetSearch from './widget_search';
import WidgetStructure from 'pa_kit/apps/structures/components/widget_structure';
import WidgetTags from 'apps/tags/components/widget_tags';
import WidgetText from '../../texts/components/widget_text';
import WidgetStaff from 'pa_kit/apps/staff/components/widget_staff';
import WidgetSector from 'pa_kit/apps/sectors/components/widget_sector';
import WidgetOffice from 'pa_kit/apps/offices/components/widget_office';
import WidgetEvent from '../../events/components/widget_event';
import WidgetDocuments from '../../documents/components/widget_documents';
import WidgetTagsHome from 'apps/tags/components/widget_tags_home';
import WidgetCalendar from 'apps/calendar/components/widget_calendar';
import WidgetSearchHome from './widget_search_home';
import WidgetGallery from 'apps/galleries/components/widget_gallery';
import WidgetPlace from 'apps/places/components/widget_place';
import WidgetCustom from 'apps/custom_widgets/components/widget_custom';
import { ActaAuthContext } from "pa_kit/auth";
import { WidgetContext } from '../models/widget';
import { PageContext } from './page';
import ApiService from "../../../services/api";
import authApiService from "pa_kit/services/api";
import WidgetStats from 'apps/stats/components/widget_stats';

const Widget = (props) => {

    const auth = useContext(ActaAuthContext);
    const widget = useContext(WidgetContext);
    const pageInfo = useContext(PageContext);

    const isActagovWebsiteEditor = auth.user && auth.user.isActagovWebsiteEditor();
    const isActagovContentEditor = auth.user && auth.user.isActagovContentEditor();

    const user = auth.user;

    const [ version, setVersion ] = useState(0);
    const [ isOpen, toggleModal ] = useState(false);
    const [ editIsOpen, toggleEditModal ] = useState(false);
    const [ isEditWidgetOpen, toggleEditWidgetModal ] = useState(false);
    
    const [ previewCss, setPreviewCss ] = useState(widget.toWidgetCss());

    const [ widgetCss, setWidgetCss ] = useState(
        widget.data.css ? Object.keys(widget.data.css).map((key) => [{css_key: key, css_value: widget.data.css[key]}]) : []
    );

    const [ widgetData, setWidgetData ] = useState({
        content_type: 'widget_section',
        layout_type: null,
        widget_item: null,
        widget_id: null,
        widget_page_slug: pageInfo.page_slug || null,
        widget_list_style: null,
        widget_menu_title: null,
        widget_search_type: null,
        widget_search_in: null,
        widget_search_id: null,
        widget_search_label: null,
        widget_calendar_label: null,
        widget_category: null,
        widget_id_tag: null,
        widget_id_office: null,
        widget_show_news_by: null,
        widget_show_number: null
    });

    const [ optionStructures, setOptionStructures ] = useState([]);
    const [ optionSectors, setOptionSectors ] = useState([]);
    const [ optionOffices, setOptionOffices ] = useState([]);
    const [ optionStaff, setOptionStaff ] = useState([]);
    const [ optionTexts, setOptionTexts ] = useState([]);
    const [ optionGalleries, setOptionGalleries ] = useState([]);
    const [ optionPlaces, setOptionPlaces ] = useState([]);
    const [ optionCustomWidgets, setOptionCustomWidgets ] = useState([]);
    const [ optionMenus, setOptionMenus ] = useState([]);
    const [ optionMainSections, setOptionMainSections ] = useState([]);
    const [ optionNewsCategories, setOptionNewsCategories ] = useState([]);
    const [ optionEventsCategories, setOptionEventsCategories ] = useState([]);
    const [ optionPlacesCategories, setOptionPlacesCategories ] = useState([]);
    const [ optionTags, setOptionTags ] = useState([]);

    const fetchStructures = async() => {
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'structure'){
            const structuresData = await authApiService.getStructures();
            if(optionStructures.length === 0) {
                structuresData.forEach(structure => {
                    optionStructures.push({value: structure.id, label: structure.name});
                });    
                setOptionStructures(optionStructures);   
            }                 
        }
    }
    
    const fetchSectors = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'sector'){
            const sectorsData = await authApiService.getSectors();
            if(optionSectors.length === 0) {
                sectorsData.forEach(sector => {
                    optionSectors.push({value: sector.id, label: sector.name});
                });    
                setOptionSectors(optionSectors);   
            } 
        }
    }

    const fetchOffices = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && (widgetData.widget_item === 'office' || widgetData.widget_item === 'news' || widgetData.widget_item === 'event')){
            const officesData = await authApiService.getOffices();
            if(optionOffices.length === 0) {
                officesData.forEach(office => {
                    optionOffices.push({value: office.id, label: office.name});
                });    
                setOptionOffices(optionOffices);   
            } 
        }
    }

    const fetchStaff = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'staff'){
            const staffData = await authApiService.getStaff();
            if(optionStaff.length === 0) {
                staffData.forEach(staff => {
                    optionStaff.push({value: staff.id, label: staff.first_name + ' ' + staff.last_name});
                });    
                setOptionStaff(optionStaff);   
            } 
        }
    }

    const fetchTexts = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'text'){
            const textsData = await ApiService.getTexts();
            if(optionTexts.length === 0) {
                textsData.forEach(text => {
                    optionTexts.push({value: text.id, label: text.name});
                });    
                setOptionTexts(optionTexts);   
            } 
        }
    }

    const fetchGalleries = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'gallery'){
            const galleriesData = await ApiService.getGalleries();
            if(optionGalleries.length === 0) {
                galleriesData.forEach(gallery => {
                    optionGalleries.push({value: gallery.id, label: gallery.name});
                });    
                setOptionGalleries(optionGalleries);   
            } 
        }
    }

    const fetchPlaces = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'place'){
            const placesData = await ApiService.getPlaces();
            if(optionPlaces.length === 0) {
                placesData.forEach(place => {
                    optionPlaces.push({value: place.slug, label: place.name});
                });    
                setOptionPlaces(optionPlaces);   
            } 
        }
    }

    const fetchCustomWidgets = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'custom_widget'){
            const customWidgetsData = await ApiService.getCustomWidgets();
            if(optionCustomWidgets.length === 0) {
                customWidgetsData.forEach(custom_widget => {
                    optionCustomWidgets.push({value: custom_widget.id, label: custom_widget.name});
                });    
                setOptionCustomWidgets(optionCustomWidgets);   
            } 
        }
    }

    const fetchMenus = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'menu'){
            const menusData = await authApiService.getMenus();
            if(optionMenus.length === 0) {
                menusData.forEach(menu => {
                    optionMenus.push({value: menu.id, label: menu.name});
                });    
                setOptionMenus(optionMenus);   
            } 
        }
    }

    const fetchMainSections = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'search'){
            const mainSectionsData = await ApiService.getMainSections();
            if(optionMainSections.length === 0) {
                mainSectionsData.forEach(main_section => {
                    optionMainSections.push({value: main_section.id, label: main_section.name});
                });    
                setOptionMainSections(optionMainSections);   
            } 
        }
    }

    const fetchNewsCategories = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'news'){
            let newsCategoriesData = await ApiService.getCategoryList();
            newsCategoriesData = newsCategoriesData.filter((category) => category.is_news === true);
            if(optionNewsCategories.length === 0) {
                optionNewsCategories.push({value: 'all', label: 'Tutte le categorie'});
                newsCategoriesData.forEach(category => {
                    optionNewsCategories.push({value: category.id, label: category.name});
                });    
                setOptionNewsCategories(optionNewsCategories);   
            } 
        }
    }

    const fetchEventsCategories = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'event'){
            let eventsCategoryData = await ApiService.getCategoryList();
            eventsCategoryData = eventsCategoryData.filter((category) => category.is_event === true);
            if(optionEventsCategories.length === 0) {
                optionEventsCategories.push({value: 'all', label: 'Tutte le categorie'});
                eventsCategoryData.forEach(category => {
                    optionEventsCategories.push({value: category.id, label: category.name});
                });    
                setOptionEventsCategories(optionEventsCategories);   
            } 
        }
    }

    const fetchPlacesCategories = async() =>{
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && widgetData.widget_item === 'place'){
            let placesCategoryData = await ApiService.getCategoryList();
            placesCategoryData = placesCategoryData.filter((category) => category.is_place === true);
            if(optionPlacesCategories.length === 0) {
                optionPlacesCategories.push({value: 'all', label: 'Tutte le categorie'});
                optionPlacesCategories.push({value: 'sticky', label: 'Luoghi in evidenza'});
                placesCategoryData.forEach(category => {
                    optionPlacesCategories.push({value: category.id, label: category.name});
                });    
                setOptionPlacesCategories(optionPlacesCategories);   
            } 
        }
    }

    const fetchTags = async() => {
        if(!user || widgetData.widget_item === null) return;
        if(user && isActagovWebsiteEditor && (widgetData.widget_item === 'news' || widgetData.widget_item === 'event' || widgetData.widget_item === 'place')){
            let tagsData = await authApiService.getTags();
            if(optionTags.length === 0) {
                tagsData.forEach(tag => {
                    optionTags.push({value: tag.id, label: tag.name});
                });    
                setOptionTags(optionTags);   
            } 
        }
    }

    useEffect(() => {
        fetchStructures();
        fetchSectors();
        fetchOffices();
        fetchStaff();
        fetchTexts();
        fetchGalleries();
        fetchPlaces();
        fetchCustomWidgets();
        fetchMenus();
        fetchMainSections();
        fetchNewsCategories();
        fetchEventsCategories();
        fetchPlacesCategories();
        fetchTags();
    }, [widgetData.widget_item]);

    const handleCloseModal = () => {
        setWidgetData({
            ...widgetData,
            content_type: 'widget_section',
            layout_type: null,
            widget_item: null,
            widget_id: null,
            widget_list_style: null,
            widget_menu_title: null,
            widget_search_type: null,
            widget_search_in: null,
            widget_search_id: null,
            widget_search_label: null,
            widget_calendar_label: null,
            widget_category: null,
            widget_id_tag: null,
            widget_id_office: null,
            widget_show_news_by: null,
            widget_show_number: null
        });
        toggleModal(false);
    }

    const handleCloseEditModal = () => {
        toggleEditModal(false);
    }

    const handleContentType = (value) => {
        switch(value) {
            case 'widget_section':
                setWidgetData({...widgetData, content_type: value, widget_item: null});
                break;

            case 'widget_item':
                setWidgetData({...widgetData, content_type: value, layou_type: null});
                break;

            default:                
                setWidgetData({...widgetData, content_type: value, layout_type: null, widget_item: null});
        }
    };

    const handleLayoutType = (value) => {
        setWidgetData({...widgetData, layout_type: value});
    };

    const handleWidgetItem = (value) => {
        setWidgetData({
            ...widgetData, 
            widget_item: value, 
            widget_id: null, 
            widget_list_style: null,
            widget_menu_title: null,
            widget_search_type: null,
            widget_search_in: null,
            widget_search_id: null,
            widget_search_label: null,
            widget_calendar_label: null,
            widget_category: null,
            widget_id_tag: null,
            widget_id_office: null,
            widget_show_news_by: null,
            widget_show_number: null
        });
    };

    const handleWidgetIDChange = (value) => {
        setWidgetData({...widgetData, widget_id: value});
    }

    const handleWidgetListStyle = (value) => {
        setWidgetData({...widgetData, widget_list_style: value});
    }

    const handleWidgetMenuTitle = (value) => {
        setWidgetData({...widgetData, widget_menu_title: value});
    }

    const handleWidgetSearchIDChange = (value) => {
        setWidgetData({...widgetData, widget_search_id: value});
    }

    const handleWidgetSearchType = (value) => {
        setWidgetData({...widgetData, widget_search_type: value});
    }

    const handleWidgetSearchLabel = (value) => {
        setWidgetData({...widgetData, widget_search_label: value});
    }

    const handleWidgetCalendarLabel = (value) => {
        setWidgetData({...widgetData, widget_calendar_label: value});
    }

    const handleWidgetCategoryChange = (value) => {
        setWidgetData({...widgetData, widget_category: value});
    }

    const handleWidgetIDTagChange = (value) => {
        setWidgetData({...widgetData, widget_id_tag: value});
    }

    const handleWidgetIDOfficeChange = (value) => {
        setWidgetData({...widgetData, widget_id_office: value});
    }

    const handleWidgetShowNumber = (value) => {
        setWidgetData({...widgetData, widget_show_number: value});
    }

    const handleShowNewsBy = (value) => {
        if(value === 'news_by_category') {
            setWidgetData({...widgetData, widget_id_office: null, widget_id_tag: null, widget_show_news_by: value});
        } else if(value === 'news_by_tags') {
            setWidgetData({...widgetData, widget_id_office: null, widget_category: null, widget_show_news_by: value});
        } else {
            setWidgetData({...widgetData, widget_id_tag: null, widget_category: null, widget_show_news_by: value});
        }        
    }

    const handleCssChange = (i, e) => {
        let newCss = [...widgetCss];        
        newCss[i][0][e.target.name] = e.target.value;               
        setWidgetCss(newCss);
    }
        
    const addCssField = () => {
        setWidgetCss([...widgetCss, [{ css_key: "", css_value: "" }]]);
    }
    
    const removeCssField = (i) => {
        let newCss = [...widgetCss];
        newCss.splice(i, 1);
        setWidgetCss(newCss);
    }

    const addChild = () => {
        widget.addChild(widgetData);
        setVersion(version + 1);
        pageInfo.page_version = pageInfo.page_version + 1;      
        setWidgetData({
            ...widgetData,
            content_type: 'widget_section',
            layout_type: null,
            widget_item: null,
            widget_id: null,
            widget_list_style: null,
            widget_menu_title: null,
            widget_search_type: null,
            widget_search_in: null,
            widget_search_id: null,
            widget_search_label: null,
            widget_calendar_label: null,
            widget_category: null,
            widget_id_tag: null,
            widget_id_office: null,
            widget_show_news_by: null,
            widget_show_number: null
        });
        toggleModal(false);
    }

    const editChild = () => {
        widget.editChild(widgetCss);
        setWidgetCss(widget.data.css ? Object.keys(widget.data.css).map((key) => [{css_key: key, css_value: widget.data.css[key]}]) : []);
        setVersion(version + 1);
        setPreviewCss(widget.toWidgetCss());
        toggleEditModal(false);
    }

    const deleteChild = () => {
        widget.deleteChild();
        setVersion(version + 1);
    }

    let content;
    let editLink = '';
    let from = window.location.href;

    let manageWidgetContent = user && isActagovWebsiteEditor && pageInfo.editMode && <>
        
        <Button onClick={() => toggleEditModal(!editIsOpen)} className="widget-edit-btn" title="CSS"> 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-filetype-css" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.397 14.841a1.13 1.13 0 0 0 .401.823c.13.108.289.192.478.252.19.061.411.091.665.091.338 0 .624-.053.859-.158.236-.105.416-.252.539-.44.125-.189.187-.408.187-.656 0-.224-.045-.41-.134-.56a1.001 1.001 0 0 0-.375-.357 2.027 2.027 0 0 0-.566-.21l-.621-.144a.97.97 0 0 1-.404-.176.37.37 0 0 1-.144-.299c0-.156.062-.284.185-.384.125-.101.296-.152.512-.152.143 0 .266.023.37.068a.624.624 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.551.05-.776.15-.225.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.122.524.082.149.2.27.352.367.152.095.332.167.539.213l.618.144c.207.049.361.113.463.193a.387.387 0 0 1 .152.326.505.505 0 0 1-.085.29.559.559 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.223-.013-.32-.04a.838.838 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765ZM.806 13.693c0-.248.034-.46.102-.633a.868.868 0 0 1 .302-.399.814.814 0 0 1 .475-.137c.15 0 .283.032.398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.441 1.441 0 0 0-.489-.272 1.838 1.838 0 0 0-.606-.097c-.356 0-.66.074-.911.223-.25.148-.44.359-.572.632-.13.274-.196.6-.196.979v.498c0 .379.064.704.193.976.131.271.322.48.572.626.25.145.554.217.914.217.293 0 .554-.055.785-.164.23-.11.414-.26.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.799.799 0 0 1-.118.363.7.7 0 0 1-.272.25.874.874 0 0 1-.401.087.845.845 0 0 1-.478-.132.833.833 0 0 1-.299-.392 1.699 1.699 0 0 1-.102-.627v-.495ZM6.78 15.29a1.176 1.176 0 0 1-.111-.449h.764a.578.578 0 0 0 .255.384c.07.049.154.087.25.114.095.028.201.041.319.041.164 0 .301-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.187.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.184.384c0 .121.047.22.143.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Z"/>
            </svg> 
        </Button>
        {widget.data.type !== 'main_wrapper' && 
            <Button className="text-danger btn-simple widget-edit-btn" title="Elimina" onClick={() => deleteChild()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-square" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </Button>
        }
            
        <Modal
            isOpen={editIsOpen}
            toggle={() => toggleEditModal(!editIsOpen)}
            labelledBy={'adminModaleditWidget'}
            centered 
            className="add-widget-modal" 
            backdrop="static"          
        >
            <ModalHeader toggle={() => handleCloseEditModal()} id={'adminModaleditWidget'}>
                <span className="ms-2" style={{color: '#ebebeb'}}>Modifica Widget</span>
            </ModalHeader>
            <ModalBody className="p-5">
            {widgetCss && widgetCss.length !== 0
                ? widgetCss.map((element, index) => 
                    <Row key={"key_cssField_" + index} className="css-item-wrapper">
                        <Col lg="3">
                            <Input type='text' name="css_key" label="Classe CSS" value={element[0].css_key} className="widget-form admin-form mb-4" onChange={(e) => handleCssChange(index, e)} />
                        </Col>
                        <Col lg="3">
                            <Input type="text" name="css_value" label="Valore" value={element[0].css_value} className="widget-form admin-form mb-4" onChange={(e) => handleCssChange(index, e)} />
                        </Col>
                        <Col lg="2" className="item-remove-btn">
                            <Button type="button" className="btn-delete-css" onClick={() => removeCssField(index)}>x Rimuovi</Button> 
                        </Col>
                    </Row>
                )
                : <p className="mb-2 add-css-label"><small>Clicca su <em>Aggiungi</em> per inserire attributi CSS</small></p>
            }                      
            <button className="btn btn-sm btn-add-css" type="button" onClick={() => addCssField()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
                Aggiungi
            </button>
            </ModalBody>
            <ModalFooter className="mt-3">     
                <center className="w-100">
                    <Row>
                        <Col>
                            <Button className="btn btn-sm btn-success w-100" onClick={(_) => editChild()}>
                                Salva
                            </Button>
                        </Col>
                    </Row>              
                </center>      
            </ModalFooter>
        </Modal>
    </>;          

    switch(widget.data.type) {
        case 'news_home':
            content = <WidgetNewsHome widget={widget} />;
            break;

        case 'tags_home':
            content = <WidgetTagsHome widget={widget} />;
            break;

        case 'search_home':
            content = <WidgetSearchHome widget={widget} />;
            break;

        case 'calendar':
            content = <WidgetCalendar widget={widget} />
            break;

        case 'text':
            content = <WidgetText widget={widget} />;
            editLink = '/admin/edit-text/' + widget.data.id_text + '/?from=' + from;
            break;

        case 'menu':
            content = <WidgetMenu widget={widget} pageInfo={pageInfo} />;
            editLink = '/admin/edit-menu/' + widget.data.id_menu + '/?from=' + from;
            break;

        case 'search':
            content = <WidgetSearch widget={widget} />;
            break;

        case 'news':
            content = <WidgetNews widget={widget} />;
            break;

        case 'event':
            content = <WidgetEvent widget={widget} />;
            break;

        case 'tags':
            content = <WidgetTags widget={widget} />;
            break;

        case 'structure':
            content = <WidgetStructure widget={widget} />;
            editLink = '/admin/edit-structure/' + widget.data.id_structure + '/?from=' + from;
            break;

        case 'staff':
            content = <WidgetStaff widget={widget} />;
            editLink = '/admin/edit-staff/' + widget.data.id_staff + '/?from=' + from;
            break;

        case 'sector':
            content = <WidgetSector widget={widget} />;
            editLink = '/admin/edit-sector/' + widget.data.id_sector + '/?from=' + from;
            break;

        case 'office':
            content = <WidgetOffice widget={widget} />;
            editLink = '/admin/edit-office/' + widget.data.id_office + '/?from=' + from;
            break;

        case 'documents':
            content = <WidgetDocuments widget={widget} />;
            break;

        case 'gallery':
            content = <WidgetGallery widget={widget} />;
            editLink = '/admin/edit-gallery/' + widget.data.id_gallery + '/?from=' + from;
            break;

        case 'place':
            content = <WidgetPlace widget={widget} />;
            break;

        case 'custom_widget':
            content = <WidgetCustom widget={widget} />;
            editLink = '/admin/edit-custom-widget/' + widget.data.id_custom_widget + '/?from=' + from;
            break;

        case 'stats':
            content = <WidgetStats widget={widget} />;
            break;

        case 'delete_item':
            content = '';
            break;

        default:
            content =   <><Row>
                        {widget.data.direction === "row"
                            ? widget.children.map((child, i) => <Col key={'key_sectionCol_' + i + widget.data.class} lg={widget.children[i].data.col_size || ''}>{child.render()}</Col>)
                            : widget.children.map((child, i) => <div key={'key_sectionCol_' + i + widget.data.class} className="w-100">{child.render()}</div>) }
                        </Row>
                        
                        {user && isActagovWebsiteEditor && pageInfo.editMode && <>                            
                            <Button className="btn btn-sm btn-secondary btn-admin" onClick={() => toggleModal(!isOpen)}>Add Widget</Button>
                            <Modal
                                isOpen={isOpen}
                                toggle={() => toggleModal(!isOpen)}
                                labelledBy={'adminModaladdWidget'}
                                centered 
                                className="add-widget-modal" 
                                backdrop="static"          
                            >
                                <ModalHeader toggle={() => handleCloseModal()} id={'adminModaladdWidget'}>
                                    <span className="ms-2" style={{color: '#ebebeb'}}>Aggiungi Widget</span>
                                </ModalHeader>
                                <ModalBody>
                                    <Form className='m-3 mb-0'>
                                        <center>
                                            <FormGroup check inline>
                                                <Input name='content_type' value="widget_section" type='radio' id='widget-section' defaultChecked onClick={(e) => handleContentType(e.target.value)} />
                                                <Label check htmlFor='widget-section'>Sezione</Label>
                                            </FormGroup>
                                            <FormGroup check inline>
                                                <Input name='content_type' value="widget_item" type='radio' id='widget-item' onClick={(e) => handleContentType(e.target.value)}  />
                                                <Label check htmlFor='widget-item'>Widget</Label>
                                            </FormGroup>
                                        </center>
                                        <hr className="divider-light mb-0" />
                                        {widgetData.content_type === 'widget_section' &&
                                            <>
                                                <center>
                                                <Row className="pt-4">
                                                    <Col>
                                                        <p className="admin-label">Scegli layout</p>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3 justify-content-around">
                                                    <Col lg="3">
                                                        <Row>
                                                            <Col lg="12" style={{ background: '#4e4e5c', height: '80px', border: '1px dashed #b3b3b3' }}>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <FormGroup check inline>
                                                                <Input name='layout_type' value="full_width" type='radio' id='layout-full-width' onClick={(e) => handleLayoutType(e.target.value)} />
                                                                <Label className="admin-label" check htmlFor='layout-full-width'>Full Width</Label>
                                                            </FormGroup>
                                                        </Row>
                                                    </Col>
                                                    <Col lg="3">
                                                        <Row className="justify-content-around" style={{ border: '1px solid #b3b3b3' }}>
                                                            <Col lg="8" style={{ background: '#4e4e5c', height: '80px', border: '1px dashed #b3b3b3' }}>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <FormGroup check inline>
                                                                <Input name='layout_type' value="boxed_width" type='radio' id='layout-boxed' onClick={(e) => handleLayoutType(e.target.value)} />
                                                                <Label className="admin-label" check htmlFor='layout-boxed'>Boxed</Label>
                                                            </FormGroup>
                                                        </Row>
                                                    </Col>
                                                    <Col lg="3">
                                                        <Row style={{ border: '1px solid #b3b3b3' }}>
                                                            <Col lg="2"></Col>
                                                            <Col lg="5" style={{ background: '#4e4e5c', height: '80px', border: '1px dashed #b3b3b3' }}></Col>
                                                            <Col lg="3" style={{ background: '#4e4e5c', height: '80px', border: '1px dashed #b3b3b3' }}></Col>
                                                            <Col lg="2"></Col>
                                                        </Row>
                                                        <Row>
                                                            <FormGroup check inline>
                                                                <Input name='layout_type' value="seven_five" type='radio' id='layout-col7-col5' onClick={(e) => handleLayoutType(e.target.value)} />
                                                                <Label className="admin-label" check htmlFor='layout-col7-col5'> Boxed Two Columns</Label>
                                                            </FormGroup>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                </center>
                                            </>
                                        }
                                            <Row className="pt-4">
                                                <Col lg="4">
                                        {widgetData.content_type === 'widget_item' &&
                                            <>
                                                <p className="admin-label">Scegli widget</p>
                                                <Row className="mt-2 add-widget-sidebar" style={{ maxHeight: '66vh', overflow: 'auto'}}>                                                            
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'structure' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('structure')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-boxes" viewBox="0 0 16 16">
                                                                    <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434L7.752.066ZM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567L4.25 7.504ZM7.5 9.933l-2.75 1.571v3.134l2.75-1.571V9.933Zm1 3.134 2.75 1.571v-3.134L8.5 9.933v3.134Zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567-2.742 1.567Zm2.242-2.433V3.504L8.5 5.076V8.21l2.75-1.572ZM7.5 8.21V5.076L4.75 3.504v3.134L7.5 8.21ZM5.258 2.643 8 4.21l2.742-1.567L8 1.076 5.258 2.643ZM15 9.933l-2.75 1.571v3.134L15 13.067V9.933ZM3.75 14.638v-3.134L1 9.933v3.134l2.75 1.571Z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Organi</p>
                                                        </div>                                                                        
                                                    </Col>
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'sector' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('sector')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-pie-chart-fill" viewBox="0 0 16 16">
                                                                    <path d="M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Settori</p>
                                                        </div>                                                                        
                                                    </Col>
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'office' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('office')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-building-fill" viewBox="0 0 16 16">
                                                                    <path d="M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Uffici</p>
                                                        </div>                                                                        
                                                    </Col>  
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'staff' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('staff')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-person-vcard-fill" viewBox="0 0 16 16">
                                                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5ZM9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8Zm1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Zm-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96c.026-.163.04-.33.04-.5ZM7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Personale</p>
                                                        </div>                                                                        
                                                    </Col>
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'text' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('text')}>
                                                            <div className="widget-item-icon">  
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-text-paragraph" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Testi</p>
                                                        </div>                                                                        
                                                    </Col>
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'gallery' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('gallery')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-images" viewBox="0 0 16 16">
                                                                    <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                                                                    <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Gallerie</p>
                                                        </div>                                                                        
                                                    </Col> 
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'place' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('place')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                                                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Luoghi</p>
                                                        </div>                                                                        
                                                    </Col>  
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'custom_widget' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('custom_widget')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-puzzle-fill" viewBox="0 0 16 16">
                                                                    <path d="M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .036-.054l.003-.01v-.008a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003l-.003-.01a.214.214 0 0 0-.036-.053.859.859 0 0 0-.27-.194C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.036.054l-.003.01v.002l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Widget Personalizzato</p>
                                                        </div>                                                                        
                                                    </Col>
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'menu' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('menu')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-list-ul" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Menù</p>
                                                        </div>                                                                        
                                                    </Col>                                                        
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'tags' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('tags')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-tag-fill" viewBox="0 0 16 16">
                                                                    <path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Argomenti</p>
                                                        </div>                                                                        
                                                    </Col>
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'search' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('search')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Cerca</p>
                                                        </div>                                                                        
                                                    </Col>                                                       
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'calendar' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('calendar')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-calendar2-week" viewBox="0 0 16 16">
                                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/>
                                                                    <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Calendario</p>
                                                        </div>                                                                        
                                                    </Col>                                                       
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'news' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('news')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-megaphone-fill" viewBox="0 0 16 16">
                                                                    <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">News</p>
                                                        </div>                                                                        
                                                    </Col>                                                       
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'event' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('event')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-calendar-event-fill" viewBox="0 0 16 16">
                                                                    <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Eventi</p>
                                                        </div>                                                                        
                                                    </Col> 
                                                    <Col lg="6" className="mb-3">
                                                        <div className={widgetData.widget_item === 'stats' ? "widget-item-wrapper active" : "widget-item-wrapper"} onClick={(e) => handleWidgetItem('stats')}>
                                                            <div className="widget-item-icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-graph-up" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z"/>
                                                                </svg>
                                                            </div>
                                                            <p className="admin-label">Statistiche</p>
                                                        </div>                                                                        
                                                    </Col>                                                       
                                                </Row>
                                            </>
                                        }
                                            </Col>
                                            <Col lg={{ size: 7, offset: 1 }}>
                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'structure' &&
                                            <>                                                               
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli tipologia</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="single_structure" type='radio' id='widget-list-style-single' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-single' className="widget-admin-radio-label">Organo Singolo</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="list" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">Elenco Organi</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_list_style === 'single_structure' && <>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='structureSelect'>Scegli Organo</Label>
                                                            <Select
                                                                id='structureSelect'
                                                                onChange={(o) => handleWidgetIDChange(o.value)}
                                                                value={optionStructures.find((o) => o.value === widgetData.widget_id)}
                                                                options={optionStructures}
                                                                placeholder='Seleziona organo'
                                                                aria-label='Seleziona organo'
                                                            />
                                                        </div>
                                                        </>                                                    
                                                    }

                                                    {widgetData.widget_list_style === 'list' && <>                   
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                   
                                                            <Row className="mt-5">
                                                                <Col>
                                                                    <Input type="text" label="Titolo elenco (es. Elenco Organi)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div>                                                                           
                                                        </>
                                                    }
                                                </div>                                
                                            </>
                                        }                                        

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'sector' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli tipologia</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="single_sector" type='radio' id='widget-list-style-single' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-single' className="widget-admin-radio-label">Settore Singolo</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="list" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">Elenco Settori</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_list_style === 'single_sector' && <>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='sectorSelect'>Scegli Settore</Label>
                                                            <Select
                                                                id='sectorSelect'
                                                                onChange={(o) => handleWidgetIDChange(o.value)}
                                                                value={optionSectors.find((o) => o.value === widgetData.widget_id)}
                                                                options={optionSectors}
                                                                placeholder='Seleziona settore'
                                                                aria-label='Seleziona settore'
                                                            />
                                                            </div>
                                                        </> 
                                                    }

                                                    {widgetData.widget_list_style === 'list' && <>                   
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                   
                                                            <Row className="mt-5">
                                                                <Col>
                                                                    <Input type="text" label="Titolo elenco (es. Elenco Settori)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div>                                                                           
                                                        </>
                                                    }
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'office' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli tipologia</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="single_office" type='radio' id='widget-list-style-single' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-single' className="widget-admin-radio-label">Ufficio Singolo</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="list" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">Elenco Uffici</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_list_style === 'single_office' && <>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='officeSelect'>Scegli Ufficio</Label>
                                                            <Select
                                                                id='officeSelect'
                                                                onChange={(o) => handleWidgetIDChange(o.value)}
                                                                value={optionOffices.find((o) => o.value === widgetData.widget_id)}
                                                                options={optionOffices}
                                                                placeholder='Seleziona ufficio'
                                                                aria-label='Seleziona ufficio'
                                                            />
                                                        </div>
                                                        </>
                                                    }

                                                    {widgetData.widget_list_style === 'list' && <>                   
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                   
                                                            <Row className="mt-5">
                                                                <Col>
                                                                    <Input type="text" label="Titolo elenco (es. Elenco Uffici)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div>                                                                           
                                                        </>
                                                    }
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'staff' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli tipologia</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="single_staff" type='radio' id='widget-list-style-single' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-single' className="widget-admin-radio-label">Persona</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="politician" type='radio' id='widget-list-style-list-politician' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list-politician' className="widget-admin-radio-label">Elenco Politici</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="admin_staff" type='radio' id='widget-list-style-list-admin-staff' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list-admin-staff' className="widget-admin-radio-label">Elenco Personale Amministrativo</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_list_style === 'single_staff' && <>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='staffSelect'>Scegli Personale</Label>
                                                            <Select
                                                                id='staffSelect'
                                                                onChange={(o) => handleWidgetIDChange(o.value)}
                                                                value={optionStaff.find((o) => o.value === widgetData.widget_id)}
                                                                options={optionStaff}
                                                                placeholder='Seleziona personale'
                                                                aria-label='Seleziona personale'
                                                            />
                                                        </div>
                                                        </>
                                                    }

                                                    {(widgetData.widget_list_style === 'politician' || widgetData.widget_list_style === 'admin_staff') && <>                   
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                   
                                                            <Row className="mt-5">
                                                                <Col>
                                                                    <Input type="text" label="Titolo elenco (es. Elenco Politici)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div>                                                                           
                                                        </>
                                                    }
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'text' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Label htmlFor='textSelect'>Scegli Testo</Label>
                                                    <Select
                                                        id='textSelect'
                                                        onChange={(o) => handleWidgetIDChange(o.value)}
                                                        value={optionTexts.find((o) => o.value === widgetData.widget_id)}
                                                        options={optionTexts}
                                                        placeholder='Seleziona testo'
                                                        aria-label='Seleziona testo'
                                                    />
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'gallery' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Label htmlFor='gallerySelect'>Scegli Galleria</Label>
                                                    <Select
                                                        id='gallerySelect'
                                                        onChange={(o) => handleWidgetIDChange(o.value)}
                                                        value={optionGalleries.find((o) => o.value === widgetData.widget_id)}
                                                        options={optionGalleries}
                                                        placeholder='Seleziona galleria'
                                                        aria-label='Seleziona galleria'
                                                    />
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'place' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli tipologia</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="single_place" type='radio' id='widget-list-style-single' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-single' className="widget-admin-radio-label">Luogo Singolo</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="list" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">Elenco Luoghi</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_list_style === 'single_place' && <>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='placeSelect'>Scegli Luogo</Label>
                                                            <Select
                                                                id='placeSelect'
                                                                onChange={(o) => handleWidgetIDChange(o.value)}
                                                                value={optionPlaces.find((o) => o.value === widgetData.widget_id)}
                                                                options={optionPlaces}
                                                                placeholder='Seleziona luogo'
                                                                aria-label='Seleziona luogo'
                                                            />
                                                        </div>
                                                        </>
                                                    }
                                                    {widgetData.widget_list_style === 'list' && <>
                                                        <Row className="mt-5">
                                                            <Col>
                                                                <p className="widget-admin-label">Mostra luoghi per</p>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <FormGroup check inline>
                                                                    <Input name='widget_show_news_by' value="news_by_category" type='radio' id='widget-show-news-by-category' onClick={(e) => handleShowNewsBy(e.target.value)} />
                                                                    <Label check htmlFor='widget-show-news-by-category' className="widget-admin-radio-label">Luoghi per categoria</Label>
                                                                </FormGroup>
                                                                <FormGroup check inline>
                                                                    <Input name='widget_show_news_by' value="news_by_tags" type='radio' id='widget-show-news-by-tags' onClick={(e) => handleShowNewsBy(e.target.value)}  />
                                                                    <Label check htmlFor='widget-show-news-by-tags' className="widget-admin-radio-label">Luoghi per argomento</Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        
                                                        {widgetData.widget_show_news_by === 'news_by_category' && <>
                                                            <Row className="mt-2">
                                                                <Col>
                                                                    <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                                        <Label htmlFor='placesCategorySelect'>Scegli Categoria</Label>
                                                                        <Select
                                                                            id='placesCategorySelect'
                                                                            onChange={(o) => handleWidgetCategoryChange(o.value)}
                                                                            value={optionPlacesCategories.find((o) => o.value === widgetData.widget_category)}
                                                                            options={optionPlacesCategories}
                                                                            placeholder='Seleziona categoria'
                                                                            aria-label='Seleziona categoria'
                                                                        />  
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            </>                                                        
                                                        }
                                                        {widgetData.widget_show_news_by === 'news_by_tags' && <>
                                                            <Row className="mt-2">
                                                                <Col>
                                                                    <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                                        <Label htmlFor='tagsSelect'>Scegli Argomento</Label>
                                                                        <Select
                                                                            id='tagsSelect'
                                                                            onChange={(o) => handleWidgetIDTagChange(o.value)}
                                                                            value={optionTags.find((o) => o.value === widgetData.widget_id_tag)}
                                                                            options={optionTags}
                                                                            placeholder='Seleziona argomento'
                                                                            aria-label='Seleziona argomento'
                                                                        />
                                                                    </div>                                                  
                                                                </Col>
                                                            </Row>
                                                            </>
                                                        }
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                   
                                                            <Row className="mt-5">
                                                                <Col>
                                                                    <Input type="text" label="Titolo elenco (es. Elenco Luoghi)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div> 
                                                        </>
                                                    }
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'custom_widget' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Label htmlFor='customWidgetSelect'>Scegli Widget Personalizzato</Label>
                                                    <Select
                                                        id='customWidgetSelect'
                                                        onChange={(o) => handleWidgetIDChange(o.value)}
                                                        value={optionCustomWidgets.find((o) => o.value === widgetData.widget_id)}
                                                        options={optionCustomWidgets}
                                                        placeholder='Seleziona widget'
                                                        aria-label='Seleziona widget'
                                                    />
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'menu' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Label htmlFor='menuSelect'>Scegli Menù</Label>
                                                    <Select
                                                        id='menuSelect'
                                                        onChange={(o) => handleWidgetIDChange(o.value)}
                                                        value={optionMenus.find((o) => o.value === widgetData.widget_id)}
                                                        options={optionMenus}
                                                        placeholder='Seleziona menù'
                                                        aria-label='Seleziona menù'
                                                    />
                                                    <Row className="mt-5">
                                                        <Col>
                                                            <Input type="text" label="Titolo Menu (facoltativo)" className="widget-form" value={widgetData.title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli stile menù</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="cards" type='radio' id='widget-list-style-cards' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-cards' className="widget-admin-radio-label">Cards</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="list" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">List</Label>
                                                    </FormGroup>
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'tags' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                    
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli stile argomenti</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="cards" type='radio' id='widget-list-style-cards' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-cards' className="widget-admin-radio-label">Cards</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="chips" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">Chips</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="tags_home" type='radio' id='widget-list-style-full' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-full' className="widget-admin-radio-label">Full</Label>
                                                    </FormGroup>
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'search' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli tipo cerca</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_search_type' value="search_home" type='radio' id='widget-search-type-home' onClick={(e) => handleWidgetSearchType(e.target.value)} />
                                                        <Label check htmlFor='widget-search-type-home' className="widget-admin-radio-label">Big Search</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_search_type' value="search_standard" type='radio' id='widget-search-type-standard' onClick={(e) => handleWidgetSearchType(e.target.value)}  />
                                                        <Label check htmlFor='widget-search-type-standard' className="widget-admin-radio-label">Standard Search</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_search_type === 'search_standard' && <>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='mainSectionSelect'>Cerca in</Label>
                                                            <Select
                                                                id='mainSectionSelect'
                                                                onChange={(o) => handleWidgetSearchIDChange(o.value)}
                                                                value={optionMainSections.find((o) => o.value === widgetData.search_id)}
                                                                options={optionMainSections}
                                                                placeholder='Seleziona sezione'
                                                                aria-label='Seleziona sezione'
                                                            />                                                    
                                                            <Row className="mt-5">
                                                                <Col>
                                                                    <Input type="text" label="Etichetta (es. Cerca in amministrazione)" className="widget-form" value={widgetData.widget_search_label} onChange={(e) => handleWidgetSearchLabel(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        </>
                                                    }
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'calendar' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                                                   
                                                    <Row className="mt-5">
                                                        <Col>
                                                            <Input type="text" label="Etichetta (es. Eventi)" className="widget-form" value={widgetData.widget_calendar_label} onChange={(e) => handleWidgetCalendarLabel(e.target.value)} />
                                                        </Col>
                                                    </Row>
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'news' &&
                                            <>                   
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                    <Row>
                                                        <Col>
                                                            <p className="widget-admin-label">Scegli stile news</p>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="news_home" type='radio' id='widget-list-style-cards' onClick={(e) => handleWidgetListStyle(e.target.value)} />
                                                        <Label check htmlFor='widget-list-style-cards' className="widget-admin-radio-label">Main news + cards</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_list_style' value="cards" type='radio' id='widget-list-style-list' onClick={(e) => handleWidgetListStyle(e.target.value)}  />
                                                        <Label check htmlFor='widget-list-style-list' className="widget-admin-radio-label">Cards</Label>
                                                    </FormGroup>
                                                    {widgetData.widget_list_style === 'cards' && <>
                                                        <Row className="mt-5">
                                                            <Col>
                                                                <p className="widget-admin-label">Mostra notizie per</p>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <FormGroup check inline>
                                                                    <Input name='widget_show_news_by' value="news_by_category" type='radio' id='widget-show-news-by-category' onClick={(e) => handleShowNewsBy(e.target.value)} />
                                                                    <Label check htmlFor='widget-show-news-by-category' className="widget-admin-radio-label">News per categoria</Label>
                                                                </FormGroup>
                                                                <FormGroup check inline>
                                                                    <Input name='widget_show_news_by' value="news_by_tags" type='radio' id='widget-show-news-by-tags' onClick={(e) => handleShowNewsBy(e.target.value)}  />
                                                                    <Label check htmlFor='widget-show-news-by-tags' className="widget-admin-radio-label">News per argomento</Label>
                                                                </FormGroup>
                                                                <FormGroup check inline>
                                                                    <Input name='widget_show_news_by' value="news_by_office" type='radio' id='widget-show-news-by-office' onClick={(e) => handleShowNewsBy(e.target.value)}  />
                                                                    <Label check htmlFor='widget-show-news-by-office' className="widget-admin-radio-label">News per ufficio</Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        
                                                        {widgetData.widget_show_news_by === 'news_by_category' && <>
                                                            <Row className="mt-2">
                                                                <Col>
                                                                    <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                                        <Label htmlFor='newsCategorySelect'>Scegli Categoria</Label>
                                                                        <Select
                                                                            id='newsCategorySelect'
                                                                            onChange={(o) => handleWidgetCategoryChange(o.value)}
                                                                            value={optionNewsCategories.find((o) => o.value === widgetData.widget_category)}
                                                                            options={optionNewsCategories}
                                                                            placeholder='Seleziona categoria'
                                                                            aria-label='Seleziona categoria'
                                                                        />  
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            </>                                                        
                                                        }
                                                        {widgetData.widget_show_news_by === 'news_by_tags' && <>
                                                            <Row className="mt-2">
                                                                <Col>
                                                                    <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                                        <Label htmlFor='tagsSelect'>Scegli Argomento</Label>
                                                                        <Select
                                                                            id='tagsSelect'
                                                                            onChange={(o) => handleWidgetIDTagChange(o.value)}
                                                                            value={optionTags.find((o) => o.value === widgetData.widget_id_tag)}
                                                                            options={optionTags}
                                                                            placeholder='Seleziona argomento'
                                                                            aria-label='Seleziona argomento'
                                                                        />
                                                                    </div>                                                  
                                                                </Col>
                                                            </Row>
                                                            </>
                                                        }
                                                        {widgetData.widget_show_news_by === 'news_by_office' && <>
                                                            <Row className="mt-2">
                                                                <Col>
                                                                    <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                                        <Label htmlFor='officeSelect'>Scegli Ufficio</Label>
                                                                        <Select
                                                                            id='officeSelect'
                                                                            onChange={(o) => handleWidgetIDOfficeChange(o.value)}
                                                                            value={optionOffices.find((o) => o.value === widgetData.widget_id_office)}
                                                                            options={optionOffices}
                                                                            placeholder='Seleziona ufficio'
                                                                            aria-label='Seleziona ufficio'
                                                                        />
                                                                    </div>                                                  
                                                                </Col>
                                                            </Row>
                                                            </>
                                                        }
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-3'>                                                   
                                                            <Row>
                                                                <Col>
                                                                    <Input type="text" label="Titolo elenco (es. Elenco Notizie)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2">
                                                                <Col>
                                                                    <Input type="number" label="News da mostrare (es. 6)" className="widget-form" value={widgetData.widget_show_number} onChange={(e) => handleWidgetShowNumber(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        </>
                                                    }                                                    
                                                </div>                                                                           
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'event' && <>  
                                            <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>                 
                                            <Row className="mt-5">
                                                <Col>
                                                    <p className="widget-admin-label">Mostra eventi per</p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <FormGroup check inline>
                                                        <Input name='widget_show_news_by' value="news_by_category" type='radio' id='widget-show-news-by-category' onClick={(e) => handleShowNewsBy(e.target.value)} />
                                                        <Label check htmlFor='widget-show-news-by-category' className="widget-admin-radio-label">Eventi per categoria</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_show_news_by' value="news_by_tags" type='radio' id='widget-show-news-by-tags' onClick={(e) => handleShowNewsBy(e.target.value)}  />
                                                        <Label check htmlFor='widget-show-news-by-tags' className="widget-admin-radio-label">Eventi per argomento</Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input name='widget_show_news_by' value="news_by_office" type='radio' id='widget-show-news-by-office' onClick={(e) => handleShowNewsBy(e.target.value)}  />
                                                        <Label check htmlFor='widget-show-news-by-office' className="widget-admin-radio-label">Eventi per ufficio</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                                        
                                            {widgetData.widget_show_news_by === 'news_by_category' && <>
                                                <Row className="mt-2">
                                                    <Col>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='newsCategorySelect'>Scegli Categoria</Label>
                                                            <Select
                                                                id='newsCategorySelect'
                                                                onChange={(o) => handleWidgetCategoryChange(o.value)}
                                                                value={optionEventsCategories.find((o) => o.value === widgetData.widget_category)}
                                                                options={optionEventsCategories}
                                                                placeholder='Seleziona categoria'
                                                                aria-label='Seleziona categoria'
                                                            />  
                                                        </div>
                                                    </Col>
                                                </Row>
                                                </>                                                        
                                            }

                                            {widgetData.widget_show_news_by === 'news_by_tags' && <>
                                                <Row className="mt-2">
                                                    <Col>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='tagsSelect'>Scegli Argomento</Label>
                                                            <Select
                                                                id='tagsSelect'
                                                                onChange={(o) => handleWidgetIDTagChange(o.value)}
                                                                value={optionTags.find((o) => o.value === widgetData.widget_id_tag)}
                                                                options={optionTags}
                                                                placeholder='Seleziona argomento'
                                                                aria-label='Seleziona argomento'
                                                            />
                                                        </div>                                                  
                                                    </Col>
                                                </Row>
                                                </>
                                            }

                                            {widgetData.widget_show_news_by === 'news_by_office' && <>
                                                <Row className="mt-2">
                                                    <Col>
                                                        <div className='bootstrap-select-wrapper form-group admin-form-standard mt-5'>
                                                            <Label htmlFor='officeSelect'>Scegli Argomento</Label>
                                                            <Select
                                                                id='officeSelect'
                                                                onChange={(o) => handleWidgetIDOfficeChange(o.value)}
                                                                value={optionOffices.find((o) => o.value === widgetData.widget_id_tag)}
                                                                options={optionOffices}
                                                                placeholder='Seleziona ufficio'
                                                                aria-label='Seleziona ufficio'
                                                            />
                                                        </div>                                                  
                                                    </Col>
                                                </Row>
                                                </>
                                            }
                                                <div className='bootstrap-select-wrapper form-group admin-form-standard mt-3'> 
                                                    <Row>
                                                        <Col>
                                                            <Input type="text" label="Titolo elenco (es. Elenco Eventi)" className="widget-form" value={widgetData.widget_menu_title} onChange={(e) => handleWidgetMenuTitle(e.target.value)} />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-4">
                                                        <Col>
                                                            <Input type="number" label="Eventi da mostrare (es. 6)" className="widget-form" value={widgetData.widget_show_number} onChange={(e) => handleWidgetShowNumber(e.target.value)} />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            </>
                                        }

                                        {widgetData.content_type === 'widget_item' && widgetData.widget_item === 'stats' && <>
                                            <Row className="mt-5">
                                                <Col>
                                                    <p className="widget-admin-label">Statistiche di accesso del sito web</p>
                                                    <p style={{color: '#ebebeb', fontSize: '14px'}}><em>Visualizza le statistiche settimanali, mensili ed annuali</em></p>
                                                </Col>
                                            </Row>
                                            </>
                                        }
                                            </Col>
                                        </Row>
                                    </Form>
                                </ModalBody>
                                <ModalFooter className="mt-3">     
                                    <center className="w-100">
                                        <Row>
                                            <Col>
                                                <Button className="btn btn-sm btn-success w-100" onClick={(_) => addChild()}>
                                                    Inserisci
                                                </Button>
                                            </Col>
                                        </Row>              
                                    </center>      
                                </ModalFooter>
                            </Modal>
                            </>
                        }
                        </>
                        
    }
    
    return <> 
    {user && isActagovWebsiteEditor && (pageInfo.editMode || pageInfo.previewMode) &&
        <style>
            {previewCss}
        </style>
    }
    {content !== '' &&       
        <Container fluid={widget.data.layout === 'fluid' ? 'fluid' : ''} className={(user && isActagovWebsiteEditor && pageInfo.editMode ? widget.data.class + ' edit-mode' : widget.data.class) + ' g-0'}>
            {content}            
            {user && isActagovWebsiteEditor &&
                <Row className="manage-widget-btn-wrapper">
                    <Col>
                        {editLink !== '' && pageInfo.editMode 
                            ? pageInfo.page_version === 0 
                                ?   <a href={editLink} title="Modifica" className="widget-edit-btn btn text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                        </svg> 
                                    </a>
                                :   <>
                                    <Button onClick={() => toggleEditWidgetModal(!isEditWidgetOpen)} className="widget-edit-btn text-primary" title="Modifica">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                        </svg>
                                    </Button>
                                    <Modal
                                        isOpen={isEditWidgetOpen}
                                        toggle={() => toggleEditWidgetModal(!isEditWidgetOpen)}
                                        centered
                                        labelledBy='editWidgetModal'
                                        className="edit-widget-modal"
                                    >
                                        <ModalHeader toggle={() => toggleEditWidgetModal(!isEditWidgetOpen)} id='editWidgetModal'>
                                            Attenzione!
                                        </ModalHeader>
                                        <ModalBody>
                                            <center>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" className="bi bi-exclamation-circle text-warning mb-3" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
                                                </svg>           
                                                <p></p>      
                                                <p style={{fontSize: "1em", fontWeight: "600"}}>Modifche non salvate!</p>
                                                <small>
                                                    <p><em>Hai apportato delle modifiche che non sono state salvate.</em></p>
                                                    <p>&nbsp;</p>
                                                    <p>Se continui senza salvare perderai tutte le modifiche.</p>
                                                    <p>Continuare?</p>
                                                </small>
                                            </center>
                                        </ModalBody>
                                        <ModalFooter className="text-center justify-content-center mt-4">
                                            <Button color='secondary' onClick={() => toggleEditWidgetModal(!isEditWidgetOpen)} style={{width: '200px'}} className="btn-sm">
                                                Annulla
                                            </Button>
                                            <a href={editLink} title="Continua" className="btn btn-primary btn-sm" style={{width: '200px'}}>
                                                Continua
                                            </a>
                                        </ModalFooter>
                                    </Modal></>
                            : ''
                        } 
                        {manageWidgetContent} 
                    </Col>
                </Row>
            }
            
             
        </Container>
    }            
    </>;
}

export default Widget;